<template>
  <div class="additional-info">
    <IconSoundLoading class="loading-icon" v-if="state === 'PENDING'" />
    <template v-else-if="state === 'ERROR'">
      <div class="wrapper-button">
        <button class="button-icon button-rounded button-gray" type="button" @click="resendMessage">
          <IconApecRefresh class="icon-smallest icon-dim" />
        </button>
        <button class="button-icon button-rounded button-gray" type="button" @click="deleteMessage">
          <IconApecClose class="icon-smallest icon-dim" />
        </button>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

import IconApecClose from '@/components/icons/IconApecClose.vue';
import IconApecRefresh from '@/components/icons/IconApecRefresh.vue';
import IconSoundLoading from '@/components/icons/IconSoundLoading.vue';
import { useMessageStore } from '@/stores/message';
import { useSocketStore } from '@/stores/socket';
import { ChatMessage, MessageState } from '@/types/socket';

const props = withDefaults(
  defineProps<{
    message: ChatMessage;
  }>(),
  {
    message: () => ({}) as ChatMessage,
  }
);
const socketStore = useSocketStore();
const messageStore = useMessageStore();

const state = computed<MessageState>(() => {
  const { state = 'SUCCESS' } = props.message;
  return state;
});

// 메시지 재전송
const resendMessage = () => {
  const { src: { contents = [] } = { contents: [] }, callLogId = '' } = props.message;
  const [{ content = '' } = { content: '' }] = contents;

  socketStore.sendMessageText({ message: content, socketId: callLogId });
};

// 메시지 삭제
const deleteMessage = () => {
  messageStore.deleteMessage(props.message.callLogId);
};
</script>

<style scoped lang="scss">
.additional-info {
  position: absolute;
  display: flex;
  height: fit-content;
  bottom: 1.25rem;
  gap: 0.25rem;
}
</style>
